import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe738380"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "icon-text-container" }
const _hoisted_3 = { class: "text-s-light" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "text-m-regular" }
const _hoisted_6 = { class: "text-s-faint mb-s" }
const _hoisted_7 = {
  key: 1,
  class: "text-empty-state"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_content_loader = _resolveComponent("base-content-loader")!
  const _component_use_svg = _resolveComponent("use-svg")!
  const _component_date_card = _resolveComponent("date-card")!
  const _component_add_to_calendar = _resolveComponent("add-to-calendar")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, { theme: "secondary" }, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_base_content_loader, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.upcomingTask)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_use_svg, {
                        svg: "home",
                        height: 15,
                        width: 15
                      }),
                      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.request.address), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "info-button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal('ModalNextVisit', { upcomingTask: _ctx.upcomingTask })))
                    }, [
                      _createVNode(_component_use_svg, { svg: "info" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_date_card, {
                      day: _ctx.formatDate(_ctx.upcomingTask.startDate, 'd'),
                      month: _ctx.formatDate(_ctx.upcomingTask.startDate, 'LLL')
                    }, null, 8, ["day", "month"]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.duration), 1),
                      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.upcomingTask.description), 1),
                      _createVNode(_component_add_to_calendar, { task: _ctx.upcomingTask }, null, 8, ["task"])
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.translate('shared.noUpcomingVisit')), 1))
          ], 64))
    ]),
    _: 1
  }))
}